import { cn } from '@/lib/utils'

export type HeaderToolbarSeparatorProps = {
  className?: string
}

/**
 * Vertical rule between toolbar clusters — same visual as `PageHeaderLeading`
 * (back | agent controls) and `ArtifactCanvasHeader` (close | title).
 */
export function HeaderToolbarSeparator({ className }: HeaderToolbarSeparatorProps) {
  return (
    <div
      role="separator"
      aria-orientation="vertical"
      className={cn('mx-1 h-5 w-px shrink-0 bg-border', className)}
    />
  )
}
